// Bundle theme module
import NSTheme from './NSTheme';
import Helper from './Classes/Helper';
import Header from './Classes/Header';
import CategoryLoader from './Classes/CategoryLoader';
import Accordion from './Classes/Accordion';
import FocusHandler from './Classes/FocusHandler';
import Jump from './Classes/Jump'
import ResponsiveTable from "./Classes/ResponsiveTable";
import LazyLoad from './Classes/Lazyload';
import NoLine from "./Classes/NoLine";
import babelpolyfill from 'babel-polyfill';
import smoothscroll from 'smoothscroll-polyfill';
import SustainabilityTabs from "./Classes/SustainabilityTabs";
import Swiper from "./lib/swiper"
import Anchor from "./Classes/Anchor";
import NoHeader from "./Classes/NoHeader";

module.exports = NSTheme;

(function () {
  document.addEventListener('DOMContentLoaded', () => {


    new Accordion({
      accordions: '.ns-accordion'
    });

    new Header();
    new CategoryLoader();
    new FocusHandler();
    new LazyLoad();

    new NoLine();
    new NoHeader();
    new SustainabilityTabs({
        tabButtonSelector: '.sustainability__button',
        tabSelector: '.sustainabiltity__tab'
      }
    );

    new Jump({
      graphicSelector: '.ns-graphic'
    });

    smoothscroll.polyfill();
    new Anchor();

    new ResponsiveTable({
      tableSelector: '.ns-table-wrap table',
      tableWrapperSelector: '.ns-table-wrap',
      breakPointLg: 1200,
      breakPointMd: 768,
      breakPointSm: 480,
      colCountNoSplit: 3,
      colCountEarlyBreak: 7,
      noSplitArray: []
    });

    const sliderContainer = document.querySelector('.swiper-container');
    if ( sliderContainer && sliderContainer != undefined) {
      Helper.loadImagesInDomElement(sliderContainer);
    }

    new Swiper('.swiper-container', {
      direction: 'horizontal',
      loop: true,
      autoplay: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
  })
})();
